export default function(value) {
  return value === Object(value);
}